import React, { useEffect, useState } from 'react';
import api from '../../../../config/axios';

import TagModal from './modals/Tag';
import Paginacao from '../../../../components/utils/paginacao';

import { FaPlus, FaFilter, FaArrowLeft, FaEllipsisV, FaEdit, FaTrashAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Tags = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const [tags, setTags] = useState([]);
    const [filtroNome, setFiltroNome] = useState('');

    const [selectedTag, setSelectedTag] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const limit = 10;

    const fetchTags = async (currentPage) => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: currentPage,
                limit: limit,
                nome: filtroNome
            };

            const response = await api.get('/tags', { params });

            setTags(response.data.records || []);
            setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
            setTotalRegistros(response.data.totalRegistros || 0);
            setError(null);
        } catch (err) {
            setError('Erro ao carregar os dados. Tente novamente mais tarde.');
        } finally {
            Swal.close();
        }
    };

    useEffect(() => {
        fetchTags(currentPage);
    }, [currentPage]);

    const handlePageChange = (currentPage) => {
        setCurrentPage(currentPage);
    };

    const handleAddTag = () => {
        setSelectedTag(null);
        setIsModalOpen(true);
    };

    const handleEditTag = (tag) => {
        setSelectedTag(tag);
        setIsModalOpen(true);
    };

    const handleDeleteTag = async (tag) => {
        const result = await Swal.fire({
            title: 'Tem certeza?',
            text: `Deseja excluir a tag "${tag.nome}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/tags/${tag.id}`);
                Swal.fire('Excluído!', 'Tag foi excluída com sucesso.', 'success');
                fetchTags(currentPage);
            } catch (error) {
                Swal.fire('Erro!', error.response?.data?.message || 'Não foi possível excluir a tag.', 'error');
            }
        }
    };

    const handleFiltrar = () => {
        setCurrentPage(1);
        fetchTags(1);
    };

    const handleLimparFiltros = () => {
        setFiltroNome('');
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedTag(null);
    };

    const handleTagAtualizada = () => {
        fetchTags(currentPage);
        handleModalClose();
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn btn-outline-secondary me-3"
                                    onClick={() => navigate('/financeiro/cadastros')}
                                    title="Voltar para Cadastros"
                                >
                                    <FaArrowLeft />
                                </button>
                                <h4 className="fw-bold mb-0">Tags</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 mb-3">
                        <div className="col-md-6 col-12">
                            <button className="btn btn-outline-primary" onClick={handleAddTag}>
                                <FaPlus /> Adicionar Tag
                            </button>
                        </div>
                    </div>

                    <div className="row mt-4 mb-4">
                        <div className="col-lg-6 col-12">
                            <label className="form-label fw-bold">Nome</label>
                            <input
                                type="text"
                                autoComplete="off"
                                placeholder="Digite o nome da tag"
                                value={filtroNome}
                                className="form-control"
                                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
                            />
                        </div>
                        <div className="col-lg-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                            <div className="d-flex gap-2 w-100 justify-content-end">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={handleLimparFiltros}
                                >
                                    Limpar
                                </button>
                                <button
                                    className="btn btn-custom-primary"
                                    onClick={handleFiltrar}
                                >
                                    <FaFilter /> Filtrar
                                </button>
                            </div>
                        </div>
                    </div>

                    {error ? (
                        <p className="error-message">{error}</p>
                    ) : (
                        <div className="d-flex flex-wrap gap-3">
                            {tags.length === 0 ? (
                                <p className="text-muted">Nenhuma tag encontrada.</p>
                            ) : (
                                tags.map((tag, index) => (
                                    <div
                                        key={index}
                                        className="d-flex align-items-center gap-1 p-2 rounded border bg-light"
                                    >
                                        <span
                                            className="badge px-3 py-2"
                                            style={{
                                                backgroundColor: tag.cor,
                                                color: getContrastColor(tag.cor),
                                                fontSize: '0.95rem'
                                            }}
                                        >
                                            {tag.nome}
                                        </span>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-link text-secondary p-1 m-0 border-0"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <FaEllipsisV size={14} />
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end">
                                                <li>
                                                    <button
                                                        className="dropdown-item d-flex align-items-center gap-2"
                                                        onClick={() => handleEditTag(tag)}
                                                    >
                                                        <FaEdit /> Editar
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        className="dropdown-item d-flex align-items-center gap-2 text-danger"
                                                        onClick={() => handleDeleteTag(tag)}
                                                    >
                                                        <FaTrashAlt /> Excluir
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <div className="mb-3">
                            <span>
                                Total de registros: <strong>{totalRegistros}</strong>
                            </span>
                        </div>
                        <Paginacao
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <TagModal
                    tag={selectedTag}
                    onClose={handleModalClose}
                    onTagAtualizada={handleTagAtualizada}
                />
            )}
        </div>
    );
};

const getContrastColor = (hexColor) => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
};

export default Tags;
